<div class="dashboard-container">
  <!-- Header Section -->
  <div class="dashboard-header">
    <div class="header-left">
      <button class="hamburger-menu" title="Menu">
        <i class="fa fa-bars" aria-hidden="true"></i>
      </button>
      <div class="header-title">
        <h1>Dashboard</h1>
        <p>Monitor your inventory performance</p>
      </div>
    </div>
    
    <div class="header-right">
      <div class="header-controls">
        <div class="dropdown-group">
          <div class="dropdown">
            <i class="fa fa-calendar" aria-hidden="true"></i>
            <span>Today</span>
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
          </div>
          <div class="dropdown">
            <i class="fa fa-store" aria-hidden="true"></i>
            <span>Tidel CBE</span>
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
          </div>
        </div>
        <div class="date-range">
          Aug 29, 2025 - Aug 29, 2025
        </div>
      </div>
      
      <div class="user-section">
        <div class="notifications">
          <i class="fa fa-bell" aria-hidden="true"></i>
          <span class="notification-badge">3</span>
        </div>
        <div class="user-info">
          <span class="user-name">Admin</span>
          <span class="user-role">Store admin role</span>
        </div>
        <div class="user-avatar">
          <i class="fa fa-user" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- Metrics Cards Section -->
  <div class="metrics-section" *ngIf="dashboardPermission === true">
    <div class="metrics-grid">
      <!-- Row 1 -->
      <div class="metric-card active" *ngIf="dashboardHeader && dashboardHeader[1]?.permission">
        <div class="metric-icon">
          <i class="fa fa-play" aria-hidden="true"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{dashboardHeader[1]?.count || '0'}}</div>
          <div class="metric-bottom">
            <div class="metric-title">ACTIVE</div>
            <div class="metric-trend">
              <span class="trend-percentage">0.00%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="metric-card consumed" *ngIf="dashboardHeader && dashboardHeader[2]?.permission">
        <div class="metric-icon">
          <i class="fa fa-check" aria-hidden="true"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{dashboardHeader[2]?.count || '0'}}</div>
          <div class="metric-bottom">
            <div class="metric-title">CONSUMED</div>
            <div class="metric-trend">
              <span class="trend-percentage">0.00%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="metric-card missing" *ngIf="dashboardHeader && dashboardHeader[3]?.permission">
        <div class="metric-icon">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{dashboardHeader[3]?.count || '0'}}</div>
          <div class="metric-bottom">
            <div class="metric-title">MISSING</div>
            <div class="metric-trend">
              <span class="trend-percentage">0.00%</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 2 -->
      <div class="metric-card expired" *ngIf="dashboardHeader && dashboardHeader[4]?.permission">
        <div class="metric-icon">
          <i class="fa fa-times" aria-hidden="true"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{dashboardHeader[4]?.count || '0'}}</div>
          <div class="metric-bottom">
            <div class="metric-title">EXPIRED</div>
            <div class="metric-trend">
              <span class="trend-percentage">0.00%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="metric-card expiring" *ngIf="dashboardHeader && dashboardHeader[5]?.permission">
        <div class="metric-icon">
          <i class="fa fa-clock-o" aria-hidden="true"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{dashboardHeader[5]?.count || '0'}}</div>
          <div class="metric-bottom">
            <div class="metric-title">EXPIRING IN 30 DAYS</div>
            <div class="metric-trend">
              <span class="trend-percentage">0.00%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="metric-card low-stock" *ngIf="dashboardHeader && dashboardHeader[6]?.permission">
        <div class="metric-icon">
          <i class="fa fa-star" aria-hidden="true"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{dashboardHeader[6]?.count || '0'}}</div>
          <div class="metric-bottom">
            <div class="metric-title">LOW STOCK</div>
            <div class="metric-trend">
              <span class="trend-percentage">0.00%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="metric-card transit" *ngIf="dashboardHeader && dashboardHeader[7]?.permission">
        <div class="metric-icon">
          <i class="fa fa-truck" aria-hidden="true"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{dashboardHeader[7]?.count || '0'}}</div>
          <div class="metric-bottom">
            <div class="metric-title">TRANSIT</div>
            <div class="metric-trend">
              <span class="trend-percentage">100.00%</span>
            </div>
          </div>
        </div>
      </div>

      <div class="metric-card devices" *ngIf="dashboardHeader && dashboardHeader[0]?.permission">
        <div class="metric-icon">
          <i class="fa fa-mobile" aria-hidden="true"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{dashboardHeader[0]?.count || '0'}}</div>
          <div class="metric-bottom">
            <div class="metric-title">DEVICES</div>
            <div class="metric-trend">
              <span class="trend-percentage">0.00%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="charts-section">
    <div class="charts-grid">
      <!-- Consumption Trend Chart -->
      <div class="chart-card">
        <div class="chart-header">
          <h3>Consumption Trend</h3>
        </div>
        <div class="chart-content">
          <div class="chart-placeholder">
            <i class="fa fa-bar-chart" aria-hidden="true"></i>
            <p>No consumption trend data available for the selected date range</p>
          </div>
        </div>
      </div>

      <!-- Top 5 Consumed Products Chart -->
      <div class="chart-card">
        <div class="chart-header">
          <h3>Top 5 Consumed Products</h3>
        </div>
        <div class="chart-content">
          <div class="chart-placeholder">
            <i class="fa fa-box" aria-hidden="true"></i>
            <p>No consumed product data available for the selected date range</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- System Status Section -->
  <div class="system-status">
    <div class="status-content">
      <i class="fa fa-check-circle" aria-hidden="true"></i>
      <div class="status-text">
        <span>All systems operational. 5 items currently in transit with 100% tracking accuracy.</span>
      </div>
    </div>
  </div>

  <!-- Help Button -->
  <div class="help-button">
    <i class="fa fa-question" aria-hidden="true"></i>
  </div>
</div>
